const transactionsResource = (() => {
	const _default_config = {
		color_codes: ["#158cdc", "#fe9006", "#079e89", "#aa55e8"],
		max_amount: 0
	};
	const init = (default_config, resource, resource_config) => {
		_default_config.max_amount = 0;
		Object.assign(_default_config, default_config);
		Object.assign(_default_config, resource_config);
		_default_config.resource = resource;
		_default_config.old_data = _default_config.data.transactions;
		_default_config.last_selected_account_number_option = _default_config._default_option;
		_default_config.last_selected_group_option = _default_config._default_option;
		_default_config.last_selected_transaction_type_option = _default_config._default_option;
		_default_config.last_selected_month_year_option = _default_config._default_option;
		_default_config.maped_data = new Map();
		_default_config._maped_data = new Map();
		updateData();
		templateEvents.updatedOnWindowResize(updateChart);
	};

	const setDefaultSlider = () => {
		let slider1 = new Slider('#ebitdaSlider1', {
			formatter: function(value) {
				return value;
			},
			tooltip: 'always',
			useCurrentValue: true
		}).on('change', function (event) {
			_default_config.max_amount = +event.newValue;
			refreshHTML();
		});
	};

	/**
	 * getAccountLevelTransactions : updating data as per requirement
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const getAccountLevelTransactions = () => {
		const tt = JSON.stringify({
			"config": {
				"account_level_high_value_transactions": {
					"bank_statement_end_point": 'summary',
					"json": true,
					...(_default_config.body.config["account_level_high_value_transactions"]["threshold_value"] && { 'threshold_value' : _default_config.body.config["account_level_high_value_transactions"]["threshold_value"] })
				}
			},
			"transaction_id": _default_config.body.transaction_id,
			"resource": ["account_level_high_value_transactions"],
		});
		const config = _default_config.apiURL.statements;
		config.data = tt;
		initScript.toggleLoader(true, true);
		HttpRequest(config, function (res) {
			initScript.toggleLoader(false, true);
			if(!!_default_config.slugs){
				res = responseV2Interceptor(res,_default_config.slugs['statements']);
			}else{
				res = responseInterceptor(res);
			}
			res = res && res.data ? res.data.data ? res.data.data : res.data : res;
			res = initScript.getObjectValue(res, "[0].data");
			var data = res; //Array.isArray(res) ? res[0].data : res.data.data[0].data;
			for (let i = 0; i < data.length; ++i) {
				const masked_account_number = templateEvents.stringMasking(data[i].account_number);
				if (_default_config.maped_data[masked_account_number].length) _default_config._maped_data.set(masked_account_number, {
					"expense": data[i].summary.expenditure,
					"revenue": data[i].summary.revenue
				});
			}
			appendHTML();
		});
	};

	/**
	 * updateChartUtil : updating data as per requirement
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const updateChartUtil = (data, id) => {
		const chart_config = _default_config.charts[_default_config.resource];
		chart_config.id  = "#" + id;
		chart_config.data  = data;
		if(false)
		charts.donut.init(chart_config);
	};

	/**
	 * bindEvents : binding events
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const bindEvents = () => {
		initScript.getHTMLElementByDelimiter("expandDescription").click(function(event) {
			initScript.getHTMLElementByDelimiter("modalBody", "#").html(event.target.attributes.data.textContent);
		});
	};

	/**
	 * updateChart : updating chart
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const updateChart = (account_number = [_default_config.last_selected_account_number_option]) => {
		let count = 0, key = "transactionsCharts";
		initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter(key), "");
		if (!!account_number && account_number.length === 1 && account_number[0].toLowerCase() === "all") {
			const itr = _default_config._maped_data.keys(), _account_number = [];
			while (1) {
				const value = itr.next().value;
				if (!!!value) break;
				_account_number.push(value);
			}
			account_number = _account_number;
		}
		for (let i = 0; i < account_number.length; ++i) {
			const config = _default_config._maped_data.get(account_number[i]);
			const chart_config = [
				{
					"value": !!config ? Math.abs(config.expense) : 0,
					"label": account_number[i]
				},
				{
					"value": !!config ? Math.abs(config.revenue) : 0,
					"label": account_number[i]
				}
			];
			if (chart_config[0].value !== 0 || chart_config[1].value !== 0) {
				templateUtil.removeEmptySection("transactionsCharts", ".");
				initScript.appendHTMLToATarget(initScript.getHTMLElementByDelimiter(key), initScript.bindAttrsOnHTMLTag("svg", "", {
					"id": key + "" + (i + 1),
					"style": { "margin": "0 20px" }
				}));
				updateChartUtil(chart_config, key + (i + 1));
			} else count++;
		}
		if (count === account_number.length) templateUtil.addEmptySection("transactionsCharts", ".");
		analyserV2.resolvePromise();
	};

	/**
	 * getMoreThanToGiveAmount : updating data as per requirement
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const getMoreThanToGiveAmount = (data) => {
		const _data = [];
		for (let i = 0; !!data && i < data.length; ++i) {
			data[i].account_number = templateEvents.stringMasking(data[i].account_number);
			if (data[i].amount >= _default_config.max_amount) _data.push(data[i]);
		}
		return _data;
	};

	/**
	 * updateData : updating data as per requirement
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const updateData = () => {
		const selected_val = _default_config._default_option, data = getMoreThanToGiveAmount(_default_config.data.transactions);
		_default_config.maped_data[selected_val] = [];
		for (let i = 0; i < data.length; ++i) {
			if (!_default_config.maped_data[data[i].account_number]) _default_config.maped_data[data[i].account_number] = [];
			// _default_config.maped_data[selected_val].push(data[i]);
			_default_config.maped_data[data[i].account_number].push(data[i]);
		}
		for(const [key, element] of Object.entries(_default_config.maped_data)){
			_default_config["defaultSortOrder"] = false;
			if(selected_val !== key){
				let sortedElement = sortManual(element) 
				_default_config.maped_data[selected_val].push(...sortedElement)
			}
		}
		getAccountLevelTransactions();
	};

	/**
	 * appendHTML : appending html
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const appendHTML = () => {
		_default_config.table_divs = _default_config.table_divs[_default_config.resource];
		_default_config.table_divs[1].columns = initScript.removeUnexpectedElements(_default_config.headers, ["bank_name"]);
		populateConsolidatedData();
	};

	/**
	 * populateConsolidatedData : showing consolidated html
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	function populateConsolidatedData() {
		_default_config.data = _default_config.maped_data[_default_config._default_option];
		if (initScript.getObjectValue(_default_config.body.config, [_default_config.resource] + ".filter.flag") !== false) {
			_default_config.account_number = templateEvents.maskingUtility(Array.from(_default_config._maped_data.keys()));
			filterData();
		}
		else {
			const node = initScript.getHTMLElementByDelimiter(_default_config.body.class), children = node.children();
			if (initScript.getHTMLElementByDelimiter("owl-carousel").length) initScript.getHTMLElementObject(children[children.length - 1]).children().children().not(":last").remove();
		}
		_default_config.data = sortManual(_default_config.data)
		_default_config.data = templateUtil.getColumnWiseData(_default_config.data, _default_config.body.config[_default_config.resource].columns)

		templateUtil.appendTabelHeaders(_default_config);
		templateUtil.appendTabelRows(_default_config);
		updateLegends();
		updateChart(_default_config.account_number);
		bindEvents();
	}

	function sortManual(data){
		if(_default_config.preSortBy && false === _default_config.preSortBy){
			return data;
		}
		else if(_default_config.preSortBy && ("amount" === _default_config.preSortBy || "running_balance" === _default_config.preSortBy)){
			return data.sort(function (a, b) {
				if(_default_config.preSortOrder && "asc" === _default_config.preSortOrder)
					return a[_default_config.preSortBy] - b[_default_config.preSortBy]; //ASC
				else
					return b[_default_config.preSortBy] - a[_default_config.preSortBy]; //DESC
			  });
		}
		else{
			_default_config["defaultSortOrder"] = (_default_config["defaultSortOrder"])?_default_config["defaultSortOrder"]:guessDefaultSortOrder(data)

			return data.sort(function (a, b) {
				var bdateParts = b.transaction_date.split("/");
				var bdateObject = new Date(+bdateParts[2], bdateParts[1] - 1, +bdateParts[0]);
				var adateParts = a.transaction_date.split("/");
				var adateObject = new Date(+adateParts[2], adateParts[1] - 1, +adateParts[0]);
				if(_default_config.preSortOrder && "asc" === _default_config.preSortOrder){
					if(adateObject.toString() === bdateObject.toString()) {
						return ("DESC" == _default_config["defaultSortOrder"])?-1:1;
					}
					return adateObject - bdateObject; //ASC
				}
				else{
					if(adateObject.toString() === bdateObject.toString()) {
						return ("DESC" == _default_config["defaultSortOrder"])?1:-1;
					}
					return bdateObject - adateObject; //DESC
				}
				
			})
		}
	}

	function guessDefaultSortOrder(data, accountNo = false) {
		var dataSet = data.reduce(function (r, a) {
			r[a.account_number] = r[a.account_number] || [];
			r[a.account_number].push(a);
			return r;
		}, Object.create(null));
		if(!accountNo)
			dataSet = dataSet[Object.keys(dataSet)[0]];
		else
			dataSet = dataSet[accountNo]
		if(!dataSet){
			return "ASC"
		}
		var first = dataSet[0]["transaction_date"].split("/");
		var last = dataSet.find(element => element.transaction_date !== first.join("/"));
		last = (last && last["transaction_date"])?last["transaction_date"].split("/"):first;
		last = new Date(+last[2], last[1] - 1, +last[0]);
		first = new Date(+first[2], first[1] - 1, +first[0]);
		if(first > last) return "DESC"
		return "ASC"
	}

	/**
	 * refreshHTML : showing consolidated html
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 * @param flag
	 */

	function refreshHTML(flag = true) {
		_default_config["defaultSortOrder"] = false
		let data = getMoreThanToGiveAmount(_default_config.maped_data[_default_config.last_selected_account_number_option]);
		if (_default_config.last_selected_group_option !== _default_config._default_option) data = initScript.filterKeyData(data, "group", _default_config.last_selected_group_option);
		if (_default_config.last_selected_transaction_type_option !== _default_config._default_option) data = initScript.filterKeyData(data, "transaction_type", _default_config.last_selected_transaction_type_option);
		if (_default_config.last_selected_month_year_option !== _default_config._default_option) data = initScript.filterKeyData(data, "month_year", _default_config.last_selected_month_year_option);
		_default_config.data = data
		if(!data.length){
			analyserV2.addAlertBox("Transactions not available!");
			var fade=document.querySelector(".alert-message-151290"),opacity=1;
			var intervalID=setInterval(function(){opacity>0?(opacity-=.01,fade.style.opacity=opacity):(clearInterval(intervalID),fade.remove())},50);		
		}
		_default_config.data = templateUtil.getColumnWiseData(_default_config.data, _default_config.body.config[_default_config.resource].columns)
		templateUtil.appendTabelRows(_default_config);
		if (flag && _default_config.last_selected_account_number_option === _default_config._default_option) updateChart(_default_config.account_number);
		else if (flag) updateChart([_default_config.last_selected_account_number_option]);
		bindEvents();
	}

	/**
	 * getTransactionsSelectedValue : transaction click event listener
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	function getTransactionsSelectedValue(event) {
		// const selected_val = event.target.value.trim(), classes = event.target.parentElement.classList.length ? event.target.parentElement.classList : event.target.classList, type = classes[classes.length - 1];
		const selected_val = event.target.value.trim(), classes = event.target.classList, type = classes[classes.length - 1];
		let flag = false;
		if (type.search("transactionType") !== -1 && _default_config.last_selected_transaction_type_option === selected_val) return;
		if (type.search("group") !== -1 && _default_config.last_selected_group_option === selected_val) return;
		if (type.search("accountNumber") !== -1 && _default_config.last_selected_account_number_option === selected_val) return;
		if (type.search("monthYear") !== -1 && _default_config.last_selected_month_year_option === selected_val) return;

		if (type.search("group") !== -1) _default_config.last_selected_group_option = selected_val;
		else if (type.search("accountNumber") !== -1) flag = true, _default_config.last_selected_account_number_option = selected_val;
		else if (type.search("transactionType") !== -1) _default_config.last_selected_transaction_type_option = selected_val;
		else if (type.search("monthYear") !== -1) _default_config.last_selected_month_year_option = selected_val;
		refreshHTML(flag);
	}

	/**
	 * filterData : filtering data
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	const filterData = () => {
		setDefaultSlider();
		let filter_options = _default_config.filter || {};
		filter_options = Object.keys(filter_options);
		for (let i = 0; i < filter_options.length; ++i) {
			const html_config = [];
			let options = templateUtil.extractData(_default_config.old_data, filter_options[i]);
			if("month_year" === filter_options[i]) options = monthYearSort(options)
			if (options.length > 1) options = [_default_config._default_option].concat(options);
			for (let j = 0; j < options.length; ++j) {
				html_config.push({
					"html": (options[j] === _default_config._default_option) ? (initScript.getObjectValue(_default_config, "body.config." + _default_config.resource + ".filter." + filter_options[i] + ".default_option") || optionsMiddleware(options[j], filter_options[i])) : optionsMiddleware(options[j], filter_options[i]),
					"config": { "value": options[j] }
				});
			}
			const other_options = initScript.getObjectValue(_default_config.body.config, _default_config.resource + ".filter." + filter_options[i] + ".other") || [];
			for (let j = 0; j < other_options.length; ++j) {
				html_config.push({
					"html": other_options[j].html,
					"config": { "value": other_options[j].value }
				});
			}
			initScript.getHTMLElementByDelimiter(initScript.keyToCamelCaseString(filter_options[i] + "_" + _default_config.resource + "_filter")).html(initScript.getCommonHTML(html_config, "option"));
		}
	};

	const monthYearSort = (param) => {
		var monthRef = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
		return param.sort(function(a,b) {
			a = a.split("-");
			b = b.split("-")
			let yearPrepend = (new Date().getFullYear()).toString().substring(0, 2);
			return new Date(yearPrepend+a[1], monthRef.indexOf(a[0]), 1) - new Date(yearPrepend+b[1], monthRef.indexOf(b[0]), 1)
		});

	};

	/**
	 * updateLegends : updating legends
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	function updateLegends() {
		let html_legends = "", options = ["Expenditure", "Revenue"];
		for (let i = 0; i < options.length; ++i) {
			let html = initScript.bindAttrsOnHTMLTag("span", "", {
				"style": { "background": _default_config.color_codes[i] }
			}) + initScript.bindAttrsOnHTMLTag("label", options[i]);
			html_legends += initScript.bindAttrsOnHTMLTag("li", html );
		}
		initScript.innerHTMLToATarget("#transactionsDonutChartegends", html_legends);
	}

	/**
	 * optionsMiddleware : filter option middleware
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 */

	function optionsMiddleware(str, filter_options) {
		if (filter_options === "account_number") return str;
		return initScript.keyToCamelCaseWithUpperCaseString(str);
	}

	return {
		init,
		getTransactionsSelectedValue
	};
})();
